import styled, { css } from "styled-components";

export const FeedButtonContainer = styled.div`
  font-size: 0;
  padding: 10px;
  display: block;

  svg {
    width: 18px;
    height: 18px;

    ${({ theme }) =>
      theme.mode === "light" &&
      css`
        filter: invert(1);
      `}
  }
`;
